import axios from "axios";

export const isLogged = () => {
    let user = localStorage.getItem("sygnalistaTopUser");

    return !isEmpty(user);
};

export const isAdmin = () => {
    if(isLogged()){
        let roleUzytkownika = JSON.parse(String(localStorage.getItem('sygnalistaTopUser'))).uzytkownik.authorities;
        return Boolean(roleUzytkownika.find((r: any) => (r.authority === 'ROLE_ADMIN')))
    }else return false
}

export const isSuperAdmin = () => {
    if(isLogged()){
        let roleUzytkownika = JSON.parse(String(localStorage.getItem('sygnalistaTopUser'))).uzytkownik.authorities;
        return Boolean(roleUzytkownika.find((r: any) => (r.authority === 'ROLE_SUPER_ADMIN')))
    }else return false
}

export const getUserInfo = () => {
    let user: any = localStorage.getItem("sygnalistaTopUser");

    if (!isEmpty(user)) {
        return (
            JSON.parse(user)
        );
    } else {
        return null;
    }
};

export const getToken = () => {
    let sesja: any = getUserInfo();

    if (!isEmpty(sesja)) {
        return sesja.credentials;
    } else {
        return null;
    }
};

export const getFirmaLink = () => {
    let link = window.location.hostname;
    // console.log(link)

    const indexOfDot = link.indexOf('-');
    if (indexOfDot === -1) {
        return link.toUpperCase(); // Jeśli nie ma kropki, zwróć cały string
    }
    return link.slice(0, indexOfDot).toUpperCase();
}

export const wyloguj = () => {
    localStorage.removeItem("sygnalistaTopUser");
    axios.defaults.headers.common.Authorization = "";
    window.location.replace('/');
};

export const isEmpty = (value: any) => {
    return (
        value === null ||
        value === undefined ||
        value === "" ||
        value.length <= 0
    );
};

export const iconTyp = (typ: string) => {
    if (!isEmpty(typ))
    {
        if(typ.indexOf('pdf') > -1)
        {
            return <i className="fa fa-file-pdf-o" style={{fontSize: '1.2rem', marginRight: '5px'}}/>
        } else if(typ.indexOf('image') > -1)
        {
            return <i className="fa fa-file-image-o" style={{fontSize: '1.2rem', marginRight: '5px'}}/>
        } else if(typ.indexOf('video') > -1)
        {
            return <i className="fa fa-film" style={{fontSize: '1.2rem', marginRight: '5px'}}/>
        } else if(typ.indexOf('compressed') > -1)
        {
            return <i className="fa fa-file-archive-o" style={{fontSize: '1.2rem', marginRight: '5px'}}/>
        } else
        {
            return <i className="fa fa-file-text-o" style={{fontSize: '1.2rem', marginRight: '5px'}}/>
        }
    }
}

export const statusyType = [{label: 'Nowe', value: 'nowe'}, {label: 'W trakcie', value: 'wTrakcie'}, {label: 'Zamknięte', value: 'zamkniete'}];
